export default {
  'profile': 'Profile',
  'editProfile': 'Edit Profile',
  'copyProfileURL': 'Copy profile URL',
  'copied': 'Copied',
  'addShortBio': 'Add a short bio',
  'toYourProfile': 'to your profile',
  'socialProfiles': 'Social Profiles',
  'addSocialProfiles': 'Add social profiles',
  'saveSocialProfiles': 'Save Social Profiles',
  'saveProfile': 'SAVE PROFILE',
  'add': 'Add',
  'edit': 'Edit',
  'save': 'Save',
  'delete': 'Delete',
  'experience': 'Experience',
  'experienceName': 'Experience name',
  'addYourExperience': 'Add your experience',
  'addExperience': 'Add Experience',
  'editExperience': 'Edit Experience',
  'saveExperience': 'Save Experience',
  'skills': 'Skills',
  'addSkills': 'Add Skills',
  'saveSkills': 'Save Skills',
  'saveTags': 'Save Tags',
  'roleInPublic': 'Public',
  'roleInPrivate': 'Private',
  'CV': 'CV',
  'statusAttached': 'Attached',
  'statusUnattached': 'Unattached',
  'role': 'Role',
  'roles': 'Roles',
  'tags': 'Tags',
  'noticePeriod': 'Notice Period',
  'contractTypes': 'Contract Types',
  'jobPreferences': 'JOB PREFERENCES',
  'salary': 'Salary',
  'viewAll': 'View all',
  'thisMeans': 'This means',
  'you': 'you',
  'phraseCriteria': 'will consider job ads that match this criteria.',
  'tooltipView': 'This profile can be viewed by others',
  'tooltipHidden': 'This profile is hidden and cannot be viewed by others',
  'savedSuccessfully': 'Saved successfully!',
  'changeAvatar': 'Change avatar',
  'changeCover': 'Change cover',
  'name': 'Name',
  'username': 'Username',
  'currentRole': 'Current role',
  'location': 'Location',
  'currentLocation': 'Current location',
  'company': 'Company',
  'companyUrl': 'Company URL',
  'from': 'From',
  'to': 'To',
  'year': 'Year',
  'iCurrentWorkHere': 'I currently work here',
  'currentCompanyName': 'Current company name *',
  'currentCompanyUrl': 'Current company URL',
  'shortBio': 'Short bio',
  'optional': 'Optional',
  'somethingAboutUrself': 'Something about yourself',
  'requiredName': 'Name is required',
  'portfolioOrWebsite': 'Portfolio or website',
  'joinCompany': 'Join community job boards',
  'yourRequest': 'Your request to join a jobs board will be reviewed by the jobs board admin. If you need supporrt please contact us through the chat widget below.',
  'jobsBoard': 'Talent pool member',
  'companyBio': 'Company bio *',
  'firstNameRequired': 'First name is required',
  'lastNameRequired': 'Last name is required',
  'companyNameRequired': 'Company name is required',
  'firstName': 'First Name *',
  'lastName': 'Last Name *',
  'keepTheProcess': 'KEEP the process moving by sending a message',
  'sendMessage': 'SEND MESSAGE',
  'skipMessage': 'SKIP MESSAGE'
}



// WEBPACK FOOTER //
// ./src/i18n/en/profile.js